import { AxiosResponse } from 'axios';
import { ON_FARM_BILLING_OVERRIDE_API_ENDPOINTS } from '../constants/apiEndpoints';
import { appContextGet, appContextPost, appContextPut, appContextDelete } from './httpCommon/appAxios.service';
import { PagedResponse } from '../types/interfaces/apiParams.interfaces';
import { AccountOnFarmBillingOverride, OnFarmEffectivePricePlan } from '../types/interfaces/onFarmBillingOverride.interfaces';

export const getOnFarmBillingOverrides = (): Promise<
  AxiosResponse<AccountOnFarmBillingOverride[] | PagedResponse<AccountOnFarmBillingOverride>>
> => {
  return appContextGet(ON_FARM_BILLING_OVERRIDE_API_ENDPOINTS.GET);
};

export const getOnFarmBillingOverrideByAccountId = (accountId: number): Promise<AxiosResponse<AccountOnFarmBillingOverride>> => {
  return appContextGet(`${ON_FARM_BILLING_OVERRIDE_API_ENDPOINTS.ACCOUNT_}${accountId}`);
};

export const getOnFarmEffectivePricePlan = (accountId: number): Promise<AxiosResponse<OnFarmEffectivePricePlan>> => {
  return appContextGet(
    `${ON_FARM_BILLING_OVERRIDE_API_ENDPOINTS.ACCOUNT_}${accountId}${ON_FARM_BILLING_OVERRIDE_API_ENDPOINTS.EFFECTIVE_PLAN}`,
  );
};

export const addOnFarmBillingOverride = (
  model: AccountOnFarmBillingOverride,
): Promise<AxiosResponse<AccountOnFarmBillingOverride>> => {
  return appContextPost(ON_FARM_BILLING_OVERRIDE_API_ENDPOINTS.GET, model);
};

export const updateOnFarmBillingOverride = (
  accountId: number,
  model: AccountOnFarmBillingOverride,
): Promise<AxiosResponse<AccountOnFarmBillingOverride>> => {
  return appContextPut(`${ON_FARM_BILLING_OVERRIDE_API_ENDPOINTS.ACCOUNT_}${accountId}`, model);
};

export const deleteOnFarmBillingOverride = (accountId: number): Promise<AxiosResponse<boolean>> => {
  return appContextDelete(`${ON_FARM_BILLING_OVERRIDE_API_ENDPOINTS.ACCOUNT_}${accountId}`);
};
